import { render, staticRenderFns } from "./BioBreaks.vue?vue&type=template&id=7466bb87&scoped=true&"
import script from "./BioBreaks.vue?vue&type=script&lang=js&"
export * from "./BioBreaks.vue?vue&type=script&lang=js&"
import style0 from "./BioBreaks.vue?vue&type=style&index=0&id=7466bb87&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7466bb87",
  null
  
)

export default component.exports